export default __webpack_public_path__ + "static/createreactapp-210130201ad83b5d463918de19c2b915.svg";